import Vue from 'vue';
import { AxiosPromise } from 'axios';
import {
  Response,
  Customer,
  EnumObject,
  DataTableRequest,
  DataTableResponse,
} from '@/models';

class CustomerService extends Vue {
  private ROOT_API = process.env.VUE_APP_ROOT_API + '/webapi/customer';

  public get(id: string): AxiosPromise<Response<Customer>> {
    return Vue.axios.get<Response<Customer>>(this.ROOT_API + '/' + id);
  }

  /**
   * Create customer
   * @param data customer data for save
   */
  public create(data: Customer): AxiosPromise<Response<Customer>> {
    return Vue.axios.post<Response<Customer>>(this.ROOT_API, data);
  }

  /**
   * Update customer
   * @param data customer data for save
   */
  public update(data: Customer): AxiosPromise<Response<Customer>> {
    return Vue.axios.put<Response<Customer>>(this.ROOT_API + '/' + data.id, data);
  }

  /**
   * Delete customer
   * @param id customer id for delete
   */
  public delete(id: string): AxiosPromise<Response<any>> {
    return Vue.axios.delete(this.ROOT_API + '/' + id);
  }

  /**
   * Validate customer
   * @param data customer data
   */
  public validate(data: Customer): AxiosPromise<Response<Customer>> {
    return Vue.axios.post<Response<Customer>>(this.ROOT_API + '/validate', data);
  }

  /**
   * Get all phone type
   */
  public getPhoneType(): AxiosPromise<Response<EnumObject[]>> {
    return Vue.axios.get<Response<EnumObject[]>>(this.ROOT_API + '/enum/phone-type');
  }

  /**
   * Get all customer of agency
   * @param request: DataTableRequest
   */
  public getAllCusstomer(request: DataTableRequest, agencyId: string): AxiosPromise<DataTableResponse<Customer>> {
    return Vue.axios.get<DataTableResponse<Customer>>(this.ROOT_API + '/get-all-customer/' + agencyId, { params: request });
  }
}
export const customerService = new CustomerService();
